<script>
    import { onMount } from 'svelte';
    import { navigate } from 'svelte-routing';
    import UserProfile from '../components/UserProfile.svelte';
    import Chat from '../components/Chat.svelte';
    import casinosStore from '../stores/casinosStore';
    import ProfilePanel from "../components/ProfilePanel.svelte";
    import { get } from 'svelte/store';
    import userStore from '../stores/userStore';
    import { clearLobbyAndTable, initGlobalSFS, updateLocation } from '../controllers/SFSController';
    import FriendsPanel from '../components/FriendsPanel.svelte';
    
    let casinos;
    let profilePanel;
    let friendsPanel;
    let isConnected;
    
    onMount(async () => {
        casinos = await casinosStore.fetchCasinos();
        console.log("casinos: " + JSON.stringify(casinos));

        initGlobalSFS();
        clearLobbyAndTable();
        setTimeout(() => {
            isConnected = true;
            updateLocation(null);
        }, 3000);  //I didn't bother to detect the true connection event to GlobalSFS, just assumed that after 3 sec it's fine to open the Friends Panel
        
	});

    function onCasino(casino) {
        navigate("/" + casino.id_ + "/lobby");
    }

    function onViewMyProfile()
    {
        if (profilePanel)
            profilePanel.show(get(userStore));
    }

    function openFriendsPanel()
    {
        if (friendsPanel)
            friendsPanel.show();
    }

</script>

<ion-header>
    <ion-toolbar>
        <div class="hbox">
            <ion-title>Casinos Map</ion-title>
            <UserProfile on:editName={onViewMyProfile}/>
        </div>
    </ion-toolbar>
  </ion-header>

<ion-content>
    <div class="hbox">
        {#if casinos}
        {#each casinos as casino}
        <div class="vbox" on:click="{onCasino(casino)}">
            <img class="casinoImage" src={casino.logo} alt={casino.name}>
            <span class="center">{casino.name}</span>
        </div>
        {/each}
        {/if}
    </div>

    <ProfilePanel bind:this={profilePanel} />
    <FriendsPanel bind:this={friendsPanel} />

</ion-content>

<ion-footer>
    {#if isConnected}
    <div style="display: flex; justify-content: flex-end; margin-right: 8px;">
        <ion-button on:click={openFriendsPanel} >Friends</ion-button>    
    </div>
    {/if}
</ion-footer>

<style>
    :global(.hbox) {
        display: flex;
        flex-direction: row;
        padding: 5px;
    }

    :global(.vbox) {
        display: flex;
        flex-direction: column;
        padding: 5px;
    }

    :global(.center) {
        display: flex;
        justify-content: center;
    }

    .casinoImage {
        width: 150px;
        height: 150px;
        margin: 2em;
        cursor: pointer;
    }
</style>